var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayButtonIcon = function SvgPlayButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 82,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.417,
    cy: 41.144,
    r: 40.28,
    fill: "#169B62",
    stroke: "#169B62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#169B62",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M62.173 42.005a1 1 0 0 0 0-1.722L32.24 22.617a1 1 0 0 0-1.508.862v35.33a1 1 0 0 0 1.508.861z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.693,
    cy: 41.144,
    r: 40.28,
    fill: "#169B62",
    stroke: "#169B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#EFE",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M62.156 42.005a1 1 0 0 0 0-1.722L32.224 22.617a1 1 0 0 0-1.508.862v35.33a1 1 0 0 0 1.508.861z"
  })));
};
export { SvgPlayButtonIcon as ReactComponent };
export default __webpack_public_path__ + "images/play-button-icon.svg";